__turbopack_context__.v({
  "root": "CoBXGa_root" + " " + __turbopack_context__.i(931616)["ctaTypeStyle"],
  "sent": "CoBXGa_sent",
});
